import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomHandler } from 'primeng/dom';

@Component({
    selector: 'agpr-light-box',
    templateUrl: './light-box.component.html',
    styleUrls: ['./light-box.component.scss'],
    standalone: false
})
export class LightBoxComponent {
    @Input() id: string;
    @Input() modal: boolean = false;

    @Output() close: EventEmitter<void> = new EventEmitter<void>();

    public zIndex: number;

    constructor() {
        // Using the z-index the way PrimeNG uses it to make sure there are no conflicts
        this.zIndex = ++DomHandler.zindex;
    }
}
